import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import $api, { API } from "../index";
import { TFeedbackRequest } from "../../types/feedback";

const feedback = createAsyncThunk<
  void,
  TFeedbackRequest,
  { rejectValue: string }
>("feedback", async (data, { rejectWithValue }) => {
  try {
    const payload = {
      type: data.type,
      name: data.name,
      email: data.email,
      subject: data.subject,
      socialNetworks: data.socialNetworks,
      fileLinks: data.fileLinks,
      label: data.label,
      message: data.message ?? data.description,
    };

    const response = await $api.post(`${API.feedback}`, payload);

    return response.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.message) {
      return rejectWithValue(e.message);
    }
    return rejectWithValue("Unexpected error");
  }
});

export default feedback;
